import React from 'react';
import PropTypes from 'prop-types';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES, ALIGN } from './constants';

const Label = ({
  align = ALIGN.left,
  for: labelFor,
  size = SIZES.medium,
  appearance = APPEARANCES.highEmphasis,
  children,
}) => {
  const labelConfig = {
    for: labelFor,
  };

  return (
    <Text
      type={TYPES.label}
      labelConfig={labelConfig}
      align={align}
      size={size}
      appearance={appearance}
    >
      {children}
    </Text>
  );
};

export default Label;

Label.propTypes = {
  for: PropTypes.string.isRequired,
  align: PropTypes.oneOf(Object.values(ALIGN)),
  size: PropTypes.oneOf(Object.values(SIZES)),
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
